import request from '@/api/base'

var testStatu = false
// 账单管理列表
const chargeBillList = params => {
  /* if (testStatu) {
    console.log('....testStatu.....' + testStatu)
    params.test = true
  }
  console.log('....testStatu.....' + testStatu) */
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/charge-bill/listTotal', params)
}
// 修改账单
const modifyBills = params => {
  return request.post('/portal/charge-bill/modifyBills', params)
}
// 账单修改历史记录查询
const billModifyHistory = params => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.get(`/portal/charge-bill/billModifyHistory?billId=${params}`)
}
// 导出账单
const exportBuildlist = (params) => {
  return request.post('/portal/charge-bill/exportList', params, { responseType: 'blob' })
}
// 导出其他账单
const exportOtherBills = (params) => {
  return request.post('/portal/contract/exportThirdPartyContractBills', params, { responseType: 'blob' })
}
// 收费账单详情
const chargeBillGet = params => {
  // if (testStatu) { params.test = true }
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/charge-bill/get', params)
}
// 根据ID查询待“收款确认”列表
const chargConfirmList = params => {
  if (testStatu) { params.test = true }
  return request.post('/portal/charge-bill/confirm-list', params)
}
const chargConfirmList2 = params => {
  if (testStatu) { params.test = true }
  return request.post('/dcits-consumption/charge-bill/confirm-list', params)
}
// 根据ID查询待“收款确认”列表
const invoiceConfirmList = params => {
  if (testStatu) { params.test = true }
  return request.post('/portal/charge-bill/invoice-list', params)
}
// 新版根据ID查询待“收款确认”列表
const invoiceConfirmListV2 = params => {
  // if (testStatu) { params.test = true }
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/charge-bill/invoice-list/v2', params)
}
// 收款确认
const chargConfirm = params => {
  if (testStatu) { params.test = true }
  return request.post('/portal/charge-bill/confirm', params)
}
// 开票确认
const invoiceConfirm = params => {
  if (testStatu) { params.test = true }
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/charge-bill/invoice', params)
}
// 开票确认
const invoiceResubmit = params => {
  return request.post('/portal/charge-bill/invoiceResubmit', params)
}

// 换开确认
const invoiceChange = params => {
  if (testStatu) { params.test = true }
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/charge-bill/invoice/change/save', params)
}

// 换开确认
const getInvoiceByBillsId = params => {
  if (testStatu) { params.test = true }
  return request.get('/portal/charge-bill/invoice/change/getByBillsId', {params})
}

// 账单缴费推送
const chargeBillPush = params => {
  if (testStatu) { params.test = true }
  return request.post('/portal/charge-bill/billPush', params)
}

// 收费管理相关
const getWithReceiveAccount = params => {
  if (testStatu) { params.test = true }
  return request.post('/portal/H5/charge-bill/getWithReceiveAccount', params)
}
// 查询账单推送配置列表
const pushSetingsList = params => {
  if (testStatu) { params.test = true }
  return request.post('/portal/bills-push-config/list', params)
}
// 保存账单推送配置列表
const pushSetingsSave = params => {
  if (testStatu) { params.test = true }
  return request.post('/portal/bills-push-config/save', params)
}
// 查询保证金台账
const queryBond = params => {
  return request.post('/portal/charge-bill/queryBond', params)
}
// 查询保证金详情附件信息
const getBondInfo = params => {
  return request.get(`/portal/charge-bill/getBondInfo/${params}`)
}
// 保证金退款、扣款
const saveBond = params => {
  return request.post('/portal/charge-bill/saveBond', params)
}

const queryRegionById = (params) => {
  // params.mockApi = true
  if (testStatu) { params.test = true }
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/queryRegionById', params)
}

const queryInvoiceInfo = (params) => {
  // params.mockApi = true
  if (testStatu) { params.test = true }
  return request.post('/portal/queryInvoiceCommonById', params)
}

const queryInvoiceDetail = (params) => {
  // params.mockApi = true
  if (testStatu) { params.test = true }
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/charge-bill/queryInvoiceDetail', params)
}

const exportInvoiceList = (params) => {
  if (testStatu) { params.test = true }
  return request.post('/portal/charge-bill/invoice-list/export', params, { responseType: 'blob' })
}

const queryCanInvoiceBills = (params) => {
  if (testStatu) { params.test = true }
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/charge-bill/queryCanInvoiceBills', params)
}

const queryInvoiceChangeDetail = (params) => {
  if (testStatu) { params.test = true }
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/charge-bill/invoice/change/queryInvoiceChangeDetail', params)
}
const addAdminRole = (params) => {
  if (testStatu) { params.test = true }
  return request.post('/portal/role/admin/addAdminRole', params)
}
const queryAdminRole = (params) => {
  if (testStatu) { params.test = true }
  return request.post('/portal/role/admin/queryAdminRole', params)
}
// 换开确认新的
const invoiceReUpdate = params => {
  return request.post('/portal/charge-bill/invoice/change/reupdate', params)
}

// 往数电平台推送数据开票
const outputinvoice = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/outputinvoice', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/outputinvoice', params)
  }
}

// 插入数电平台补录数据
const addInvShudianSupplementData = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    params.mockApi = false
    return request.post('/invEnterprise/addInvShudianSupplementData', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/addInvShudianSupplementData', params)
  }
}
// 补录数据-根据发票申请id查询开票状态
const queryInvStatus = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    params.mockApi = false
    return request.post('/invEnterprise/queryInvStatus', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/queryInvStatus', params)
  }
}

// 数电平台-补录数据-平台流水号查询
const queryInvShudianSupplementDataPlatform = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/queryInvShudianSupplementDataPlatform?platformNum=' + params.platformNum, params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/queryInvShudianSupplementDataPlatform?platformNum=' + params.platformNum, params)
  }
}

// 补录数据-平台流水号查询，仅查本地数据
const querySDBLDataByPlatform = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/querySDBLDataByPlatform?platformNum=' + params.platformNum, params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/querySDBLDataByPlatform?platformNum=' + params.platformNum, params)
  }
}

// 根据invoiceNo查询下载地址
const queryQdInvoice = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.get('/invEnterprise/queryQdInvoice', {params})
  } else {
    return request.get('/dcits-consumption/invEnterprise/queryQdInvoice', {params})
  }
}
// 红冲原申请、开蓝票（新申请）
const fastRedAndNewInvoice = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/fastRedAndNewInvoice', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/fastRedAndNewInvoice', params)
  }
}

// 查询字典数据
const selectConfigDictList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/configDict/selectConfigDictList', params)
  } else {
    return request.post('/dcits-consumption/configDict/selectConfigDictList', params)
  }
}
// 根据企业id分页查询营业抽成数据
const selectMerchantsWithdrawPage = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/selectMerchantsWithdrawPage?current=' + params.current + '&size=' + params.size, params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/selectMerchantsWithdrawPage?current=' + params.current + '&size=' + params.size, params)
  }
}
// 根据企业id查询营业抽成的费用区间和账单金额
const selectMerchantsWithdraw = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/selectMerchantsWithdraw?feeType=' + params.feeType + '&id=' + params.id, params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/selectMerchantsWithdraw?feeType=' + params.feeType + '&id=' + params.id, params)
  }
}
// 修改提现账单的开票金额
const updateWithdrawFeeDetail = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/updateWithdrawFeeDetail', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/updateWithdrawFeeDetail', params)
  }
}
// 查询换开时所有已开发票的金额
const selectAllInvoicedAmounts = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/selectAllInvoicedAmounts', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/selectAllInvoicedAmounts', params)
  }
}
const selectReceiveBillsInvoice = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/selectReceiveBillsInvoice', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/selectReceiveBillsInvoice', params)
  }
}
const updateReceiveInvoiceAmount = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/updateReceiveInvoiceAmount', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/updateReceiveInvoiceAmount', params)
  }
}
const selectInvoiceCommonChange = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/invEnterprise/selectInvoiceCommonChange', params)
  } else {
    return request.post('/dcits-consumption/invEnterprise/selectInvoiceCommonChange', params)
  }
}

export default {
  selectInvoiceCommonChange,
  updateReceiveInvoiceAmount,
  selectReceiveBillsInvoice,
  selectAllInvoicedAmounts,
  updateWithdrawFeeDetail,
  selectMerchantsWithdraw,
  selectMerchantsWithdrawPage,
  selectConfigDictList,
  fastRedAndNewInvoice,
  queryInvShudianSupplementDataPlatform,
  queryQdInvoice,
  addInvShudianSupplementData,
  queryInvStatus,
  outputinvoice,
  chargeBillList,
  exportOtherBills,
  chargeBillGet,
  chargConfirm,
  exportBuildlist,
  chargeBillPush,
  chargConfirmList,
  chargConfirmList2,
  getWithReceiveAccount,
  invoiceConfirmList,
  invoiceConfirm,
  invoiceResubmit,
  pushSetingsList,
  pushSetingsSave,
  queryBond,
  getBondInfo,
  saveBond,
  queryRegionById,
  queryInvoiceInfo,
  invoiceChange,
  getInvoiceByBillsId,
  modifyBills,
  billModifyHistory,
  invoiceConfirmListV2,
  queryInvoiceDetail,
  exportInvoiceList,
  queryCanInvoiceBills,
  queryInvoiceChangeDetail,
  addAdminRole,
  queryAdminRole,
  invoiceReUpdate,
  querySDBLDataByPlatform
}



// WEBPACK FOOTER //
// ./src/area-contract/api/chargeService.js